import React, { useState, useRef, useEffect } from "react";
import { Menu, MenuItem, ProSidebar, SubMenu } from 'react-pro-sidebar';
import { Link, useLocation } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { Box, Typography } from "@mui/material";
import { SelectPicker, Placeholder } from 'rsuite';
import ipo from "../images/ipo.svg";
import Request from "../images/Request.svg";
import MismatchedData from "../images/MismatchedData.svg";

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [selectedMenuItem, setSelectedMenuItem] = useState('');
  const [openSubMenu, setOpenSubMenu] = useState('');
  const sidebarRef = useRef(null);
  const roleName = localStorage.getItem('novaRolename');
  const currentLocation = useLocation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsCollapsed(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Set the open submenu based on the current location
    if (currentLocation.pathname.startsWith("/compliance-reports") || currentLocation.pathname.startsWith("/company-profile") || currentLocation.pathname.startsWith("/StockReport") || currentLocation.pathname.startsWith("/RecentlyChangedSymbols"))  {
      setOpenSubMenu('Stocks');
    } else if (currentLocation.pathname.startsWith("/ETFS") || currentLocation.pathname.startsWith("/ETFHoldingsBasket") ||  currentLocation.pathname.startsWith("/ETFAnalytics") || currentLocation.pathname.startsWith("/UncoveredStock") || currentLocation.pathname.startsWith("/ETFPurification") || currentLocation.pathname.startsWith("/ZakatCalculator") || currentLocation.pathname.startsWith("/FinancialLabelsSettings") || currentLocation.pathname.startsWith("/ETFHistory"))  {
      setOpenSubMenu('ETFS');
    } else if (currentLocation.pathname.startsWith("/IRITaskManager") || currentLocation.pathname.startsWith("/IRILibrary") ||  currentLocation.pathname.startsWith("/IRILibrary") ||  currentLocation.pathname.startsWith("/IRIComplianceReport")) {
      setOpenSubMenu('ESG');
    } else if (currentLocation.pathname.startsWith("/MarketsSettings") || currentLocation.pathname.startsWith("/Empty-ISINS") || currentLocation.pathname.startsWith("/UsersandRoles") ) {
      setOpenSubMenu('Settings');
    } else if (currentLocation.pathname.startsWith("/Requests") || currentLocation.pathname.startsWith("/UpdateRequests") || currentLocation.pathname.startsWith("/CoverageRequests") ) {
      setOpenSubMenu('Requests');
    }
    else if (currentLocation.pathname.startsWith("/Logout")) {
      setOpenSubMenu('Account');
    } else {
      setOpenSubMenu('');
    }
  }, [currentLocation]);

  const handleMouseEnter = () => {
    setIsCollapsed(false);
  };

  const handleMouseLeave = () => {
    setIsCollapsed(false);
  };

  const handleMouseMove = () => {
    setIsCollapsed(false);
  };

  const handleSidebarClick = (event) => {
    event.stopPropagation();
  };

  const handleOutsideClick = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsCollapsed(true); // Close the sidebar drawer
    }
  };

  // Add event listener to handle outside clicks
  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <>
      <Box onMouseMove={handleMouseMove}>
        <div id="sidebarTrigger" onClick={() => setIsCollapsed(!isCollapsed)}></div>
        <ProSidebar
          collapsed={isCollapsed}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          ref={sidebarRef}
          styles={{
            transition: 'transform 0.10s ease', // Adjust the transition duration here (0.5s)
            transform: isCollapsed ? 'translateX(-260px)' : 'translateX(0)'
          }}
        >
          <Menu iconShape="square">
            <Box>
              <Typography
                variant="h6"
                sx={{ m: "15px 0 5px 20px" }}
              >
                Mains ({roleName})
              </Typography>

              <MenuItem 
                className={selectedMenuItem === 'TaskManager' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('TaskManager'); setOpenSubMenu('TaskManager'); }}
                active={currentLocation.pathname === "/TaskManager"}
              >
                <i className="icon-union"></i> <Link to="/TaskManager">Task Manager</Link>
              </MenuItem>

              
              <MenuItem 
                className={selectedMenuItem === 'Ranking' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('Ranking'); setOpenSubMenu('Ranking'); }}
                active={currentLocation.pathname === "/Ranking"}
              >
                <i className="icon-ScoringRanking"></i> <Link to="/Ranking">Scoring & Ranking</Link>
              </MenuItem>

              <MenuItem 
                className={selectedMenuItem === 'Dashboard' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('Dashboard'); setOpenSubMenu('Dashboard'); }}
                active={currentLocation.pathname === "/Dashboard"}
              >
                <i className="icon-home"></i> <Link to="/Dashboard">Dashboard</Link> 
              </MenuItem>
              
              <SubMenu 
                title={<><i className="custom-icon icon-graph"></i> Stocks</>}
                open={openSubMenu === 'Stocks'} 
                onOpen={() => setOpenSubMenu('Stocks')} 
                onClick={() => setOpenSubMenu('Stocks')}
              >
                <MenuItem 
                  className={selectedMenuItem === 'Compliance' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('Compliance'); setOpenSubMenu('Stocks'); }}
                  active={currentLocation.pathname === "/compliance-reports"}
                >
                  <Link to="/compliance-reports">Compliance Reports</Link>
                </MenuItem>
                <MenuItem  
                  className={selectedMenuItem === 'Company' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('Company'); setOpenSubMenu('Stocks'); }}
                  active={currentLocation.pathname === "/company-profile"}
                >
                  <Link to="/company-profile">Company Profile</Link>
                </MenuItem>
                <MenuItem  
                  className={selectedMenuItem === 'Report' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('Report'); setOpenSubMenu('Stocks'); }}
                  active={currentLocation.pathname === "/StockReport"}
                >
                  <Link to="/StockReport">Reports</Link>
                </MenuItem> 
                
                <MenuItem  
                  className={selectedMenuItem === 'History' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('Report'); setOpenSubMenu('History'); }}
                  active={currentLocation.pathname === "/History"}
                >
                  <Link to="/History">History</Link>
                </MenuItem>   

                <MenuItem  
                  className={selectedMenuItem === 'ManualCompanies' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('Report'); setOpenSubMenu('ManualCompanies'); }}
                  active={currentLocation.pathname === "/ManualCompanies"}
                >
                  <Link to="/ManualCompanies">Manual Companies</Link>
                </MenuItem>

                 <MenuItem  
                  className={selectedMenuItem === 'RecentlyChangedSymbols' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('Report'); setOpenSubMenu('RecentlyChangedSymbols'); }}
                  active={currentLocation.pathname === "/RecentlyChangedSymbols"}
                >
                  <Link to="/RecentlyChangedSymbols">Recent Company Changes</Link>
                </MenuItem>



              </SubMenu>

                                 
           


              
              <SubMenu 
                title={<><i className="custom-icon icon-ETF"></i> ETFS</>}
                open={openSubMenu === 'ETFS'} 
                onOpen={() => setOpenSubMenu('ETFS')} 
                onClick={() => setOpenSubMenu('ETFS')}
              >
                <MenuItem 
                  className={selectedMenuItem === 'ETFs' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('ETFs'); setOpenSubMenu('ETFS'); }}
                  active={currentLocation.pathname === "/ETFS"}
                >
                  <Link to="/ETFS">ETFs</Link>
                </MenuItem>
                <MenuItem 
                  className={selectedMenuItem === 'HoldingBasket' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('HoldingBasket'); setOpenSubMenu('ETFS'); }}
                  active={currentLocation.pathname === "/ETFHoldingsBasket"}
                >
                  <Link to="/ETFHoldingsBasket">ETF Holding Basket</Link>
                </MenuItem>   

                <MenuItem 
                  className={selectedMenuItem === 'ETFAnalytics' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('ETFAnalytics'); setOpenSubMenu('ETFS'); }}
                  active={currentLocation.pathname === "/ETFAnalytics"}
                >
                  <Link to="/ETFAnalytics">ETF Analytics</Link>
                </MenuItem>   

                <MenuItem 
                  className={selectedMenuItem === 'UncoveredStock' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('UncoveredStock'); setOpenSubMenu('ETFS'); }}
                  active={currentLocation.pathname === "/UncoveredStock"}
                >
                  <Link to="/UncoveredStock">Uncovered Stock</Link>
                </MenuItem> 

                <MenuItem 
                  className={selectedMenuItem === 'ETFPurification' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('ETFPurification'); setOpenSubMenu('ETFS'); }}
                  active={currentLocation.pathname === "/ETFPurification"}
                >
                  <Link to="/ETFPurification">Purification</Link>
                </MenuItem> 

                 <MenuItem 
                  className={selectedMenuItem === 'ZakatCalculator' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('ZakatCalculator'); setOpenSubMenu('ETFS'); }}
                  active={currentLocation.pathname === "/ZakatCalculator"}
                >
                  <Link to="/ZakatCalculator">Zakat</Link>
                </MenuItem> 

                   <MenuItem 
                  className={selectedMenuItem === 'FinancialLabelsSettings' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('FinancialLabelsSettings'); setOpenSubMenu('ETFS'); }}
                  active={currentLocation.pathname === "/FinancialLabelsSettings"}
                >
                  <Link to="/FinancialLabelsSettings">Zakat Library</Link>
                </MenuItem> 

                <MenuItem 
                  className={selectedMenuItem === 'ETFHistory' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('ETFHistory'); setOpenSubMenu('ETFS'); }}
                  active={currentLocation.pathname === "/ETFHistory"}
                >
                  <Link to="/ETFHistory">ETF History</Link>
                </MenuItem> 


              

              </SubMenu> 

              
              <SubMenu title={<><i className="custom-icon icon-ETF"></i> ISRI</>} open={openSubMenu === 'ESG'} onOpen={() => setOpenSubMenu('ESG')} onClick={() => setOpenSubMenu('ESG')} >
                 <MenuItem className={selectedMenuItem === 'IRITaskManager' ? 'active' : ''} onClick={() => { setSelectedMenuItem('IRITaskManager'); setOpenSubMenu('IRITaskManager'); }} active={currentLocation.pathname === "/IRITaskManager"} >
                 <Link to="/IRITaskManager">Task Manager</Link>
              </MenuItem>
              <MenuItem className={selectedMenuItem === 'IRILibrary' ? 'active' : ''} onClick={() => { setSelectedMenuItem('IRILibrary'); setOpenSubMenu('IRILibrary'); }} active={currentLocation.pathname === "/IRILibrary"} >
                 <Link to="/IRILibrary">Library</Link>
              </MenuItem>
                 <MenuItem className={selectedMenuItem === 'IRIProfile' ? 'active' : ''} onClick={() => { setSelectedMenuItem('IRIProfile'); setOpenSubMenu('IRIProfile'); }} active={currentLocation.pathname === "/IRIProfile"} >
                 <Link to="/IRIProfile">ISRI Profile</Link>
              </MenuItem>
               <MenuItem className={selectedMenuItem === 'IRIComplianceReport' ? 'active' : ''} onClick={() => { setSelectedMenuItem('IRIComplianceReport'); setOpenSubMenu('IRIComplianceReport'); }} active={currentLocation.pathname === "/IRIComplianceReport"} >
                 <Link to="/IRIComplianceReport">ISRI Compliance Report</Link>
              </MenuItem>
              </SubMenu>   

            
             {/* <SubMenu title={<><i className="custom-icon icon-ETF"></i> IPO</>} open={openSubMenu === 'IPO'} onOpen={() => setOpenSubMenu('IPO')} onClick={() => setOpenSubMenu('IPO')} >
                 <MenuItem className={selectedMenuItem === 'ipocompanies' ? 'active' : ''} onClick={() => { setSelectedMenuItem('ipocompanies'); setOpenSubMenu('ipocompanies'); }} active={currentLocation.pathname === "/ipocompanies"} >
                 <Link to="/ipocompanies">IPO Calendar</Link>
              </MenuItem>
              <MenuItem className={selectedMenuItem === 'IRILibrary' ? 'active' : ''} onClick={() => { setSelectedMenuItem('IRILibrary'); setOpenSubMenu('IRILibrary'); }} active={currentLocation.pathname === "/IRILibrary"} >
                 <Link to="/IRILibrary">IPO Profile Mismatch</Link>
              </MenuItem>
               <MenuItem className={selectedMenuItem === 'IRIComplianceReport' ? 'active' : ''} onClick={() => { setSelectedMenuItem('IRIComplianceReport'); setOpenSubMenu('IRIComplianceReport'); }} active={currentLocation.pathname === "/IRIComplianceReport"} >
                 <Link to="/IRIComplianceReport">IPO Profiles Synced</Link>
              </MenuItem>
              </SubMenu> */}
{/* 
              <MenuItem 
                className={selectedMenuItem === 'ipocompanies' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('ipocompanies'); setOpenSubMenu('ipocompanies'); }}
                active={currentLocation.pathname === "/ipocompanies"}
              >
                <img src={ipo}/> <Link to="/ipocompanies">IPO Calendar</Link>
              </MenuItem> */}
              
              <SubMenu 
                title={<><img src={Request} /> Requests</>}
                open={openSubMenu === 'Requests'} 
                onOpen={() => setOpenSubMenu('Requests')} 
                onClick={() => setOpenSubMenu('Requests')}
              > 
             

              <MenuItem 
                className={selectedMenuItem === 'UpdateRequests' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('UpdateRequests'); setOpenSubMenu('UpdateRequests'); }}
                active={currentLocation.pathname === "/UpdateRequests"}
              >
                {/* <i className="icon-update-request"></i>  */}
                <Link to="/UpdateRequests">Update Requests</Link>
              </MenuItem> 
              <MenuItem 
                className={selectedMenuItem === 'CoverageRequests' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('CoverageRequests'); setOpenSubMenu('CoverageRequests'); }}
                active={currentLocation.pathname === "/CoverageRequests"}
              >
                {/* <i className="icon-coverage-request"></i>  */}
                <Link to="/CoverageRequests">Coverage Requests</Link>
              </MenuItem> 
              </SubMenu>

              <MenuItem 
                className={selectedMenuItem === 'MissingCompanies' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('MissingCompanies'); setOpenSubMenu('MissingCompanies'); }}
                active={currentLocation.pathname === "/MissingCompanies"}
              >
                <i className="icon-missing-company"></i> <Link to="/MissingCompanies">Missing Companies</Link>
              </MenuItem>


              
              <MenuItem 
                className={selectedMenuItem === 'DeletedReports' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('DeletedReports'); setOpenSubMenu('DeletedReports'); }}
                active={currentLocation.pathname === "/DeletedReports"}
              >
                <i className="icon-deleted-report"></i> <Link to="/DeletedReports">Deleted Reports</Link>
              </MenuItem>

               <MenuItem 
                className={selectedMenuItem === 'VisitorAnalytics' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('VisitorAnalytics'); setOpenSubMenu('VisitorAnalytics'); }}
                active={currentLocation.pathname === "/VisitorAnalytics"}
              >
                <i className="icon-deleted-report"></i> <Link to="/VisitorAnalytics">Visitor Analytics</Link>
              </MenuItem>


              


         

              {/* <MenuItem 
                className={selectedMenuItem === 'ETFErrorListing' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('ETFErrorListing'); setOpenSubMenu('ETFErrorListing'); }}
                active={currentLocation.pathname === "/ETFErrorListing"}
              >
                <i className="icon-deleted-report"></i> <Link to="/ETFErrorListing">ETF Error Listing</Link>
              </MenuItem>
              
             
              <MenuItem 
                className={selectedMenuItem === 'AUMNullData' ? 'active' : ''} 
                onClick={() => { setSelectedMenuItem('AUMNullData'); setOpenSubMenu('AUMNullData'); }}
                active={currentLocation.pathname === "/AUMNullData"}
              >
                <i className="icon-deleted-report"></i> <Link to="/AUMNullData">AUM Null Data</Link>
              </MenuItem> */}

              

              
              <Typography
                variant="h6"
                sx={{ m: "15px 0 5px 20px" }}
                className="menu_setting_section"
              >
                Settings
              </Typography>
              <SubMenu 
                title={<><i className="custom-icon icon-user"></i> Account</>}
                open={openSubMenu === 'Account'} 
                onOpen={() => setOpenSubMenu('Account')} 
                onClick={() => setOpenSubMenu('Account')}
              >
                <MenuItem 
                  className={selectedMenuItem === 'Logout' ? 'active' : ''} 
                  onClick={() => { setSelectedMenuItem('Logout'); setOpenSubMenu('Logout'); localStorage.removeItem('isLoggedIn'); }}
                  active={currentLocation.pathname === "/"}
                >
                  <Link to="/">Logout</Link>
                </MenuItem>                                   
              </SubMenu> 

              <SubMenu title={<><i className="custom-icon icon-setting"></i> Settings</>} open={openSubMenu === 'Settings'} onOpen={() => setOpenSubMenu('Settings')} onClick={() => setOpenSubMenu('Settings')} >
           
              {roleName === 'MERLIN_ADMIN' && (
              <MenuItem className={selectedMenuItem === 'UsersandRoles' ? 'active' : ''} onClick={() => { setSelectedMenuItem('Settings'); setOpenSubMenu('Settings'); }} active={currentLocation.pathname === "/UsersandRoles"} >
                  <Link to="/UsersandRoles">Users And Roles</Link>
                </MenuItem> 
              )}

                <MenuItem className={selectedMenuItem === 'MarketsSettings' ? 'active' : ''} onClick={() => { setSelectedMenuItem('Settings'); setOpenSubMenu('Settings'); }} active={currentLocation.pathname === "/MarketsSettings"} >
                  <Link to="/MarketsSettings">Markets Settings</Link>
                </MenuItem> 
                <MenuItem className={selectedMenuItem === 'Empty-ISINS' ? 'active' : ''} onClick={() => { setSelectedMenuItem('Settings'); setOpenSubMenu('Settings'); }} active={currentLocation.pathname === "/Empty-ISINS"} >
                  <Link to="/Empty-ISINS">Finnhub-Musaffa Data</Link>
                </MenuItem>                                   
              </SubMenu> 
            </Box>
          </Menu>
        </ProSidebar>
      </Box>
    </>
  );
};

export default Sidebar;
